import { z } from 'zod';

/**
 * Menus por empresa (Sessao 37). A empresa liga/desliga itens do menu lateral. SO EXIBICAO: o item desligado some do menu, da busca
 * (Ctrl K), dos favoritos e do Copiloto, e a rota mostra "area desativada para esta empresa"; a API continua respondendo e nada e apagado.
 * Vale por cima do perfil de atividade (o menu mostra o que esta ligado E cabe na atividade). Padrao: tudo ligado (lista vazia).
 * Os valores sao rotas do menu; `apps/web/.../navegacao.test.ts` confere que esta lista e a do menu sao a mesma.
 */
export const ROTAS_DESLIGAVEIS = [
  '/precificar/formacao',
  '/precificar/lista',
  '/precificar/simulador',
  '/precificar/margens',
  '/vender/orcamentos',
  '/clientes',
  '/plano',
  '/plano/carteira',
  '/plano/necessidade',
  '/plano/compras',
  '/plano/custo-fabrica',
  '/plano/fluxo',
  '/custos/fichas-tecnicas',
  '/custos/atualizacoes',
  '/custos/pessoal',
  '/custos/criterios',
  '/custos/configuracoes-rateio',
  '/custos/cifs',
  '/custos/itens-cif',
  '/custos/rateios',
  '/cadastros/itens',
  '/cadastros/categorias',
  '/cadastros/unidades',
  '/cadastros/fornecedores',
  '/cadastros/imobilizados',
  '/custos/centros',
  '/cadastros/pessoas',
  '/cadastros/cargos',
  '/cadastros/tabelas',
  '/cadastros/condicoes',
] as const;
export type RotaDesligavel = (typeof ROTAS_DESLIGAVEIS)[number];

/** PUT /empresa/menus: as rotas desligadas (sem repetir; so rotas do menu). Lista vazia = tudo ligado. */
export const menusEmpresaSchema = z.object({
  menusDesligados: z
    .array(z.enum(ROTAS_DESLIGAVEIS))
    .refine((a) => new Set(a).size === a.length, 'Item de menu repetido'),
});
export type MenusEmpresaDto = z.infer<typeof menusEmpresaSchema>;

/** Item do menu que governa a rota: o de prefixo mais longo ("/plano/carteira/x" -> "/plano/carteira"; "/plano" nao engole "/plano/fluxo"). */
function itemDaRota(rota: string): RotaDesligavel | undefined {
  let achado: RotaDesligavel | undefined;
  for (const r of ROTAS_DESLIGAVEIS) {
    if ((rota === r || rota.startsWith(`${r}/`)) && (!achado || r.length > achado.length)) achado = r;
  }
  return achado;
}

/** A rota (ou uma subrota dela) esta desligada para a empresa? Rotas fora da lista (inicio, ajuda, configuracoes) nunca desligam. */
export function rotaDesligada(rota: string, desligados: readonly string[] | undefined): boolean {
  if (!desligados || desligados.length === 0) return false;
  const item = itemDaRota(rota);
  return item !== undefined && desligados.includes(item);
}
